import EditTemplate from "../_templates/EditTemplate";
import { umpireSchema } from "../../../schemas/umpire.schema";
import { getUmpire, updateUmpire } from "../../../api/coredata.api";

export default function EditUmpire() {
  return (
    <EditTemplate
      title="Edit Umpire"
      schema={umpireSchema}
      fetchFn={getUmpire}
      updateFn={updateUmpire}
      redirectPath="/cricket/umpires"
    />
  );
}
